<template>
  <div>
    <div>
      <jd-tips>
        <p>1、非官方权益，商家自定义实物奖品信息</p>
        <p>2、线下手动发放</p>
      </jd-tips>
      <div class="topTip">
        <div class="beans">
          <img
            src="@/assets/images/integralCenter/physical.png"
            style="width: 80px"
          />
        </div>
        <div class="count">
          <span>可用库存：</span>
          <span style="color: #2768ff">{{ remanentAmount }}件</span>
        </div>
      </div>
      <input-form
        ref="inputForm"
        :inputData="inputData"
        :pageName="pageName"
        :btnPosition1="true"
        @toParentVal="searchContent"
      ></input-form>
    </div>
    <div class="table-box">
      <el-button type="primary" @click="handleCreate">
        <img
          src="@/assets/images/member/new_establish.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin-right: 3px;
          "
        />
        创建实物</el-button
      >
      <div class="table-box-bottom">
        <el-table
          :data="tableData"
          v-loading="tableLoading"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%"
          max-height="500"
        >
          <template slot="empty">
            <div>
              <img
                src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
              />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="goodsName" label="实物名称" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.goodsName }}</div>
              <div class="copy">
                <span>id：{{ scope.row.id }}</span>
                <img
                  src="@/assets/images/integralCenter/copy.svg"
                  alt
                  v-clipboard:copy="scope.row.id"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  class="copy-img"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="实物图片" width="120">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.image"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="internalNumber"
            label="商家内部编号"
            width="100"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.internalNumber">
                {{ scope.row.internalNumber }}
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="计划描述" width="180">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.description"
                placement="right-start"
                v-if="
                  scope.row.description && scope.row.description.length > 20
                "
              >
                <div>{{ descLimit(scope.row.description) }}</div>
              </el-tooltip>
              <div
                v-else-if="
                  scope.row.description && scope.row.description.length < 20
                "
              >
                {{ scope.row.description }}
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column label="库存模式" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.inventoryType === 0">限制库存</span>
              <span v-else-if="scope.row.inventoryType === 1">不限库存</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalAmount" label="库存总量" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.totalAmount >= 0">{{
                scope.row.totalAmount
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sendOutGoodsAmount"
            label="已发货数量"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="waitSendOutGoodsAmount"
            label="待发货数量"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="remanentAmount" label="剩余库存" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.remanentAmount >= 0">{{
                scope.row.remanentAmount
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                class="operation"
                style="margin-right: 12px"
                @click="edit(scope.row)"
                >编辑</span
              >
              <span
                class="operation"
                @click="handleDelete(scope.row)"
                style="margin-right: 12px"
                >删除</span
              >
              <span
                v-if="scope.row.inventoryType == 0"
                class="operation"
                @click="addOrReduce(scope.row)"
                style="margin-right: 12px"
                >增减库存</span
              >
              <span
                style="color: #ccc;margin-right: 12px"
                v-else
                :disabled="scope.row.inventoryType == 1"
                >增减库存</span
              >
              <span class="operation" @click="grantRecord(scope.row)"
                >发放记录</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="text-align: right"
        :current-page="formData.current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="formData.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="total"
      ></el-pagination>
    </div>
    <createPrize
      v-if="isShowCreate"
      :dialogFormVisible="isShowCreate"
      :isEdit="isEdit"
      :editForm="editForm"
      @close="isShowCreate = false"
      @handleCreateSuccess="handleCreateSuccess"
    ></createPrize>
    <inventory
      v-if="isShowInventory"
      :isShowInventory="isShowInventory"
      :editForm="editForm"
      @close="closeFn"
    ></inventory>
  </div>
</template>
<script>
import jdTips from "@/components/common/jdTips.vue";
import inputForm from "@/components/inputForm";
import createPrize from "./dialog/createPrize.vue";
import inventory from "./dialog/inventory.vue";
import {
  getGoodsPage,
  getAllRemanentAmount,
  deleteGoods,
} from "@/api/integralCenter/physical.js";
export default {
  components: {
    inputForm,
    createPrize,
    inventory,
    jdTips,
  },
  props: {},
  data() {
    return {
      editForm: {},
      remanentAmount: 0,
      isEdit: false,
      grantObj: {},
      isShowInventory: false,
      isShowCreate: false,
      formData: {
        current: 1,
        size: 10,
        goodsName: "",
        internalNumber: "",
        startTime: "",
        endTime: "",
        createByMe: false,
      },
      total: 0,
      inputData: [
        {
          name: "实物名称",
          val: "goodsName",
          placeholder: "请输入",
        },
        {
          name: "内部编号",
          val: "internalNumber",
          placeholder: "请输入",
        },
        {
          name: "创建时间",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
      ],
      tableLoading: false,
      tableData: [],
    };
  },
  computed: {
    descLimit() {
      return (desc) => {
        if (desc) {
          return desc.length > 20 ? desc.substring(0, 20) + "..." : desc;
        } else {
          return "";
        }
      };
    },
    pageName: function() {
      return "忠诚度管理-实物管理";
    },
  },
  watch: {},
  mounted() {
    this.getRemanentAmount();
    this.$nextTick(() => {
      this.$refs.inputForm.formSearch();
    });
  },
  methods: {
    async getRemanentAmount() {
      const res = await getAllRemanentAmount();
      if (res.code == 1) {
        this.remanentAmount = res.data;
      }
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    async getList() {
      try {
        this.tableLoading = true;
        const res = await getGoodsPage(this.formData);
        if (res.code == 1) {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = Number(res.data.total);
        }
      } catch (error) {
        this.tableLoading = false;
      }
    },
    handleCreateSuccess(flag) {
      this.isShowCreate = flag;
      this.$nextTick(() => {
        this.$refs.inputForm.formSearch();
      });
      this.getRemanentAmount();
    },
    closeFn(flag) {
      this.isShowInventory = false;
      if (flag) {
        this.$nextTick(() => {
          this.$refs.inputForm.formSearch();
        });
        this.getRemanentAmount();
      }
    },
    searchContent(val, type) {
      let createByMe = this.formData.createByMe;
      this.formData = {
        ...val,
        current: 1,
        size: 10
      };
      if (type == "reset") {
        this.formData.createByMe = false;
      } else {
        this.formData.createByMe = createByMe;
      }
      this.getList();
    },
    handleCreate() {
      this.isEdit = false;
      this.isShowCreate = true;
    },
    handleCreateByMe() {
      this.getList();
    },
    edit(row) {
      this.editForm = row;
      this.isEdit = true;
      this.isShowCreate = true;
    },
    handleDelete(row) {
      this.$confirm("是否删除实物?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(async () => {
          const res = await deleteGoods(row.id);
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.$nextTick(() => {
              this.$refs.inputForm.formSearch();
            });
            this.getRemanentAmount();
          } else {
            this.$confirm(res.data.message, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              iconClass: "iconfont iconicon-jinggao1",
            })
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch(() => {});
    },
    addOrReduce(row) {
      this.editForm = row;
      this.isShowInventory = true;
    },
    grantRecord(row) {
      this.grantObj = { goodsId: row.id, activeIndex: 2 };
      this.$emit("checkGrantRecord", this.grantObj);
    },
    //分页变化事件
    handleSizeChange(val) {
      this.formData.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formData.current = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.top-tips {
  margin-bottom: 20px;
}
.operation {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
}
.topTip {
  display: flex;
  align-items: center;
  position: relative;
  background: #fafafa;
  height: 120px;
  margin: 30px;
  .beans {
    margin: 20px;
  }
  .count {
    font-size: 14px;
    color: #666666;
  }
}
.table-box {
  padding: 0 30px;
  &-bottom {
    margin: 16px 0 20px 0;
  }
  .copy {
    display: flex;
    align-items: center;
    &-img {
      width: 16px;
      height: 16px;
      cursor: pointer;
      margin-left: 4px;
    }
  }
}
</style>
